

function Login(props) {

    const updateUser = props.updateUser

    // const login = () => {
    //     updateUser(1);
    // }
    const login = (e) => {
        e.preventDefault();
        if (e.target[0].value=="krzwl"){
            updateUser(1);
        }
    }

    return (
        <div className="relative flex flex-col items-center gap-1 select-none">
            {/* Background glow */}
            <div className="absolute inset-0 -z-10 pointer-events-none flex items-center justify-center">
                <div style={{
                    width: '500px', height: '500px',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(255,238,0,0.07) 0%, transparent 70%)',
                    filter: 'blur(40px)',
                }} />
            </div>

            <h1 className="font-Tsukimi text-[#ffee00] text-[7rem] leading-none tracking-tight"
                style={{ textShadow: '0 0 60px rgba(255,238,0,0.25), 0 0 120px rgba(255,238,0,0.1)' }}>
                mixbus
            </h1>
            <p className="text-[#444] text-[10px] tracking-[0.45em] uppercase mb-6">coming soon</p>

            <form onSubmit={login} className="flex flex-col gap-2 w-[260px]">
                <input
                    type="password"
                    placeholder="password"
                    className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg px-4 py-3 text-sm text-white outline-none placeholder-[#3a3a3a] transition-all duration-200 focus:border-[#ffee00] focus:shadow-[0_0_0_2px_rgba(255,238,0,0.1)]"
                />
                <button
                    type="submit"
                    className="bg-[#ffee00] text-black font-bold text-xs py-3 rounded-lg tracking-[0.2em] uppercase transition-all duration-200 hover:bg-[#ffe000] hover:shadow-[0_4px_20px_rgba(255,238,0,0.25)] active:scale-95"
                >
                    Enter
                </button>
            </form>
        </div>
    );
}

export default Login;